import React from 'react';
import './OurTeam.css';

import raquelPhoto from '../assets/raquel.jpg';
import redPhoto from '../assets/red.jpg';
import sheenaPhoto from '../assets/Sheenav2.jpg';
import geraldPhoto from '../assets/Geraldv2.jpg';

const photoMap = {
  'raquel.jpg': raquelPhoto,
  'red.jpg': redPhoto,
  'Sheenav2.jpg': sheenaPhoto,
  'Geraldv2.jpg': geraldPhoto,
};

const MemberItem = ({ title, description, technologies, memberPhoto }) => (
  <div className="member-item">
    <h3>{title}</h3>
    <p>{description}</p>

    <div className="member-technologies">
        <img src={photoMap[memberPhoto]} alt={technologies[0]} className='member-photo' />
    </div>
  </div>
);

const OurTeam = () => {
  const memberData = [
    {
      title: 'Raquel Mati',
      description: 'Raquel brings a wealth of experience in software development, project management, and healthcare technology. Her collective expertise spans various domains, including clinical systems, patient management platforms, and health data analytics. She is passionate about leveraging technology to create meaningful change in the healthcare sector, and dedicated to continuous learning and innovation to stay at the forefront of industry trends.',
      technologies: ['.NET Core', 'SignalR'],
      memberPhoto: 'raquel.jpg'
    },
    {
      title: 'Red Mati',
      description: 'A hands-on engineering leader with 11+ years as a full-stack software engineer and over a decade in technical leadership. Red brings rare depth from nearly ten years at Pegasus Health (2011–2021), where he progressed from Senior Developer through to Technical Lead and ultimately Product Manager on the South Island eReferral platform - a mission-critical system serving five DHB regions across Aotearoa. Most recently, he led a team of 10+ engineers at Xero, delivering high-traffic cloud services at scale on AWS and Kubernetes. Red has now turned his full focus to Innodata, channelling that enterprise-grade experience into building impactful digital solutions for New Zealand organisations.',
      technologies: ['React', 'D3.js', 'Node.js', 'WebSocket'],
      memberPhoto: 'red.jpg'
    },
    {
      title: 'Sheena Elaine Mati',
      description: 'An experienced technology leader with proven track record in building high-quality, enterprise-grade applications using the Java ecosystem. Her unique value lies in a hybrid skill set that extends beyond technical mentorship. Adept at performing detailed business analysis, engaging with stakeholders to define scope and ensure products are perfectly aligned with business needs. Strong commitment to entire product lifecycle, creating and leading user training sessions to empower customers and guarantee a smooth transition from development to implementation.',
      technologies: ['Angular', 'Java Spring', 'PostgreSQL', 'AWS'],
      memberPhoto: 'Sheenav2.jpg'
    },
    {
      title: 'Gerald Mati',
      description: 'Gerald is a seasoned Engineer and Technical Specialist with deep expertise in architecting and delivering mission-critical solutions at scale. Highly skilled in Java-based stacks and API-first design, he builds high-availability, low-latency services that form the backbone of enterprise systems. Gerald also brings specialised expertise in payment gateway engineering, having designed and delivered Java-powered international payment exchange solutions for global customers - handling complex multi-currency flows, high-throughput transaction processing, and the rigorous security standards that global financial platforms demand. His combination of enterprise engineering excellence and fintech domain depth is a key asset of Innodata.',
      technologies: ['Angular', 'Java Spring', 'PostgreSQL', 'AWS'],
      memberPhoto: 'Geraldv2.jpg'
    },
  ];

  return (
    <section id="ourteam" className="section members-section">
      <div className="section-content">
        <h1>Meet our team</h1>
        <p className="subtitle">Our top talents driving our IT solutions</p>
        <div className="members-grid">
          {memberData.map((teamMember, index) => (
            <MemberItem
              key={index}
              title={teamMember.title}
              description={teamMember.description}
              technologies={teamMember.technologies}
              memberPhoto={teamMember.memberPhoto}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
